<template>
  <div
    id="export-subscriptions"
  >
    <h2>Export Subscriptions</h2>

    <subscription-nav />

    <form
      :action="actionUrl"
      method="post"
      v-on:submit.prevent="submit"
    >
      <fieldset>
        <legend>Export Criteria</legend>

        <div class="form-group row">
          <div class="col">
            <div class="calendar">
              <label
                for="subscription_start_ts"
              >
                Start Date
              </label>

              <input
                type="date"
                class="form-control"
                name="subscription[start_ts]"
                id="subscription_start_ts"
              />
            </div>
          </div>

          <div class="col">
            <div class="calendar">
              <label
                for="subscription_end_ts"
              >
                End Date
              </label>

              <input
                type="date"
                class="form-control"
                name="subscription[end_ts]"
                id="subscription_end_ts"
              />
            </div>
          </div>
        </div>

      </fieldset>

      <tag-select
        type="subscription"
        :selectedTags="tagSlugs"
        hideCreate
      />

      <div
        class="form-group"
      >
        <button
          class="btn btn-primary btn-block"
        >
          Export CSV
        </button>
      </div>
    </form>

    <div
      v-if="csv"
    >
      <pre>{{ csv }}</pre>

    </div>
  </div>
</template>

<script>
import SubscriptionNav from '@/components/SubscriptionNav'
import TagSelect from '@/components/TagSelect'

import TagMixin from '@/mixins/TagMixin'

import FlashStore from '@/stores/FlashStore'

export default {
  components: {
    'subscription-nav': SubscriptionNav,
    'tag-select': TagSelect
  },

  props: {
    tagId: {
      type: String,
      default: undefined
    }
  },

  data () {
    return {
      csv: undefined,
      end_ts: undefined,
      start_ts: undefined,
      tags: []
    }
  },

  computed: {
    actionUrl () {
      return this.apiUrl('/export_subscriptions', true)
    }
  },

  mixins: [ TagMixin ],

  methods: {
    submit (ev) {
      this.bindSubmit(ev).then((resp) => {
        let headers = resp.headers
        const filename = 'exported.csv'
        const str = resp.body
        const contentType = headers['Content-Type']

        this.$root.downloadStr(str, filename, contentType)

        FlashStore.result('Subscriptions exported.')
      }, this.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExportSubscriptions.vue